import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";

const routes: Routes = [

	// default redirect
	{
		path: "",
		loadChildren: () => import('./webapp/pages/contracts/funnel/redirect/redirect.module').then(m => m.RedirectModule),
		data: { title: 'Energia Rinnovabile e Sostenibile » ènostra' }
	},

    // admin
    {
        path: "",
        loadChildren: () => import('./admin/layout/layout.module').then(m => m.LayoutModule)
    },

    // webapp
    {
		path: "",
		loadChildren: () => import('./webapp/layout/layout.module').then(m => m.WebAppLayoutModule),
    },

    // not found
    {
        path: "notfound",
        loadChildren: () => import('./shared/pages/page-not-found/pagenotfound.module').then(m => m.PageNotFoundModule),
        data: { title: 'Modules.Shared.PageNotFound.PageTitle' }
    },

    // forbidden
    {
        path: "forbidden",
        loadChildren: () => import('./shared/pages/forbidden/forbidden.module').then(m => m.ForbiddenModule),
        data: { title: 'Modules.Shared.Forbidden.PageTitle' }
    },

    // 404 page not found
    //----------------------------------------------------------
    {
        path: "**",
        redirectTo: "notfound"
    }
];

const routerOptions: ExtraOptions = {
	useHash: false,
	anchorScrolling: 'enabled',
	scrollPositionRestoration: 'enabled',
	/*bindToComponentInputs: true*/
};

@NgModule({
    imports:
        [
            RouterModule.forRoot(routes, routerOptions)
        ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
